<template>
<section>


    <div class="container-fluid whole-contact-block">
        <div class="row">
            <div class="offset-2 col-md-12 text-align-left">
            <h1>
                Where you can find me:
            </h1>

            </div>
        </div>

        

        


<div class="media-container-row">


        <ContactCard title="Linkedin" socicon="linkedin" link="https://www.linkedin.com/in/eduluz/"/>
        <ContactCard title="Github" socicon="github" link="https://github.com/eduluz1976"/>
        <ContactCard title="Twitter" socicon="twitter" link="https://twitter.com/eduluz1976"/>
</div>

<div class="media-container-row">
        <ContactCard title="Dev.To" imageLink="https://d2fltix0v2e0sb.cloudfront.net/dev-badge.svg"  
            link="https://dev.to/eduluz1976"/>

        <ContactCard title="Angellist" socicon="angellist" link="https://angel.co/eduardo-luz"/>
        

</div>

    </div>
</section>    
</template>

<script>
import ContactCard from "./ContactCard.vue";

export default {
    components: { ContactCard }
}
</script>

<style scoped>

.whole-contact-block {
    background-color: #ddd;
    margin-top: 2em;
    padding-top: 1em;
    padding-bottom: 2em;
}


</style>